import * as React from 'react';

const SeminarSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 17h16V4H4v13zm7.5-15v1H3v14H2v1h8.3L7 21.3l.7.7 3.8-3.8V22h1v-3.8l3.8 3.8.7-.7-3.3-3.3H22v-1h-1V3h-8.5V2h-1z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 8v5h4V8H6zm3 4H7V9h2v3zM12 12h4v1h-4zM12 10h6v1h-6zM12 8h4v1h-4z"
        />
    </svg>
);

SeminarSvg.displayName = 'SeminarSvg';
export default SeminarSvg;
